import { createSelector } from "../../../utils/createSelector.js";
export var gridHeaderFilteringStateSelector = function(state) {
    return state.headerFiltering;
};
export var gridHeaderFilteringEnabledSelector = createSelector(gridHeaderFilteringStateSelector, // No initialization in MIT, so we need to default to false to be used by `getTotalHeaderHeight`
function(headerFilteringState) {
    var _headerFilteringState_enabled;
    return (_headerFilteringState_enabled = headerFilteringState === null || headerFilteringState === void 0 ? void 0 : headerFilteringState.enabled) !== null && _headerFilteringState_enabled !== void 0 ? _headerFilteringState_enabled : false;
});
export var gridHeaderFilteringEditFieldSelector = createSelector(gridHeaderFilteringStateSelector, function(headerFilteringState) {
    return headerFilteringState.editing;
});
export var gridHeaderFilteringMenuSelector = createSelector(gridHeaderFilteringStateSelector, function(headerFilteringState) {
    return headerFilteringState.menuOpen;
});
